/* eslint-disable @typescript-eslint/no-explicit-any */
interface LanguageJson {
    [key: string]: any;
  }
  
  export const getLanguageCode = (
    engLang: LanguageJson,
    spanLang: LanguageJson
  ): LanguageJson => {
    const languageCode = localStorage.getItem("_languageCode") ?? "en";
    return languageCode === "en" ? engLang : spanLang;
  };
  